/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UserRole = {
    Reader: 'Reader',
    Agent: 'Agent',
    TeamManager: 'TeamManager',
    Reviewer: 'Reviewer',
    ReviewManager: 'ReviewManager',
    Auditor: 'Auditor',
    Configurator: 'Configurator',
    Admin: 'Admin',
    JackBurtonAdmin: 'JackBurtonAdmin'
} as const;
export type UserRole = typeof UserRole[keyof typeof UserRole];


export function UserRoleFromJSON(json: any): UserRole {
    return UserRoleFromJSONTyped(json, false);
}

export function UserRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRole {
    return json as UserRole;
}

export function UserRoleToJSON(value?: UserRole | null): any {
    return value as any;
}

